import React from "react";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import "./CartDrawer.css";

const CartDrawer = () => {
	const { items, itemCount, subtotal, isCartOpen, setIsCartOpen, removeItem, updateQuantity } = useCart();
	const navigate = useNavigate();

	const handleCheckout = () => {
		setIsCartOpen(false);
		navigate("/checkout");
	};

	const handleContinueShopping = () => {
		setIsCartOpen(false);
	};

	return (
		<>
			<div
				className={`cart-overlay ${isCartOpen ? "active" : ""}`}
				onClick={() => setIsCartOpen(false)}
			/>
			<div className={`cart-drawer ${isCartOpen ? "active" : ""}`}>
				<div className="cart-drawer-header">
					<h3>Your Cart ({itemCount})</h3>
					<button className="cart-close" onClick={() => setIsCartOpen(false)}>
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
						</svg>
					</button>
				</div>

				{items.length === 0 ? (
					<div className="cart-empty">
						<p className="cart-empty-text">Your cart is empty</p>
						<button className="cart-continue-btn" onClick={handleContinueShopping}>
							Continue Shopping
						</button>
					</div>
				) : (
					<>
						<div className="cart-items">
							{items.map((item) => (
								<div key={item.id} className="cart-item">
									<div className="cart-item-image">
										<img src={item.images[0]} alt={item.title} />
									</div>
									<div className="cart-item-details">
										<h4 className="cart-item-title">{item.title}</h4>
										<p className="cart-item-price">${item.price.toFixed(2)}</p>
										<div className="cart-item-actions">
											<div className="cart-quantity">
												<button
													className="qty-btn"
													onClick={() => updateQuantity(item.id, item.quantity - 1)}
												>
													-
												</button>
												<span className="qty-value">{item.quantity}</span>
												<button
													className="qty-btn"
													onClick={() => updateQuantity(item.id, item.quantity + 1)}
												>
													+
												</button>
											</div>
											<button
												className="cart-remove"
												onClick={() => removeItem(item.id)}
											>
												Remove
											</button>
										</div>
									</div>
								</div>
							))}
						</div>

						<div className="cart-footer">
							<div className="cart-subtotal">
								<span>Subtotal</span>
								<span>${subtotal.toFixed(2)}</span>
							</div>
							<p className="cart-shipping-note">
								Shipping calculated at checkout
							</p>
							<button className="cart-checkout-btn" onClick={handleCheckout}>
								Checkout
							</button>
							<button className="cart-continue-link" onClick={handleContinueShopping}>
								Continue Shopping
							</button>
						</div>
					</>
				)}
			</div>
		</>
	);
};

export default CartDrawer;
